import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CrmUrl, FetchCallLog } from '../redux/apicalling/dispatchfunction';
import person from "../assets/images/person.svg"
import '../assets/css/calllogpage.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FiPhoneIncoming, FiPhoneOutgoing, FiPhone, FiMic } from 'react-icons/fi';
import PopupScreen from './popupScreen';
import { faEye } from '@fortawesome/free-solid-svg-icons';

function CallLog() {
  const [contacts, setContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [skip, setSkip] = useState(0);
  const [take] = useState(10);
  const [hasMore, setHasMore] = useState(true);
  const [activeTab, setActiveTab] = useState('all'); // 'all' or 'missed'
  const customerinfo = useSelector((state) => state.crmcustomerinfo);

  const observer = useRef();
  const [callDates, setCallDates] = useState([]);
  const agent = localStorage.getItem("username");
  const liveCall = JSON.parse(localStorage.getItem("livecall"));

  const config = JSON.parse(localStorage.getItem("config")).projects[0]
  const userPermission = config.userPermission;
  const audioRef = useRef(null);

  const dispatch = useDispatch();

  const fetchContacts = useCallback(async (skipValue, searchTermValue, statusFilter = null) => {
    console.log("StatusFilter==========>", statusFilter);

    dispatch(FetchCallLog({
      agent: statusFilter == "ABANDON" ? "All" : agent,
      skip: skipValue,
      take: take,
      phone_number: searchTermValue,
      //status: statusFilter // Add status filter to API call if provided
    })).then((response) => {
      if (response.status === 200) {
        const data = response.data.data;

        const formattedDates = data.map((contact) => formatDate(contact.calldate));
        setCallDates((prevCallDates) => [...prevCallDates, ...formattedDates]);

        if (data.length < take) {
          setHasMore(false);
        }

        if (skipValue === 0) {
          setContacts(data);
          setFilteredContacts(data);
        } else {
          setContacts((prevContacts) => [...prevContacts, ...data]);
          setFilteredContacts((prevContacts) => [...prevContacts, ...data]);
        }
      } else {
        setContacts([])
        setFilteredContacts([])
        setHasMore(false);
      }

    }).catch((err) => {
      return err
    })
  }, [agent, take]);

  useEffect(() => {
    // Reset skip and fetch new contacts when tab changes
    setSkip(0);
    setHasMore(true);
    setCallDates([]);

    if (activeTab === 'missed') {
      fetchContacts(0, searchQuery, 'ABANDON');
    } else {
      fetchContacts(0, searchQuery);
    }
  }, [activeTab, fetchContacts, searchQuery]);

  useEffect(() => {
    if (skip > 0) {
      if (activeTab === 'missed') {
        fetchContacts(skip, searchQuery, 'ABANDON');
      } else {
        fetchContacts(skip, searchQuery);
      }
    }
  }, [skip, fetchContacts, searchQuery, activeTab]);

  useEffect(() => {
    if (liveCall) {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    }
  }, [liveCall])

  useEffect(() => {
    // Filter contacts based on search term (client-side filtering as fallback)
    let filtered = contacts.filter((contact) =>
      contact.phone_number.includes(searchTerm)
    );

    // If server-side filtering didn't work, do client-side filtering
    if (activeTab === 'missed') {
      filtered = filtered.filter(contact => contact.status === 'ABANDON');
    }

    setFilteredContacts(filtered);
  }, [searchTerm, activeTab, contacts]);

  const lastContactElementRef = useRef();

  const formatStatus = (status) => {
    switch (status) {
      case 'COMPLETE':
        return 'Completed';
      case 'ABANDON':
        return 'Missed';
      case 'NOANSWER':
        return 'No Answer';
      default:
        return status;
    }
  };

  const lastContactCallback = useCallback(
    (node) => {
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setSkip((prevSkip) => prevSkip + take);
        }
      });
      if (node) observer.current.observe(node);
    },
    [hasMore, take]
  );

  const fetchCallRecording = (recordUrl) => {
    try {
      if (audioRef.current) {
        if (audioRef.current.src === recordUrl) {
          if (audioRef.current.paused) {
            audioRef.current.play().then(() => console.log('this is user audio success')).catch(() => console.log('this is user audio fail'));
          } else {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
          }
        } else {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          audioRef.current.src = recordUrl;
          audioRef.current.play().then(() => console.log('this is user audio success')).catch(() => console.log('this is user audio fail'));
        }
      } else {
        audioRef.current = new Audio(recordUrl);
        audioRef.current.play().then(() => console.log('this is user audio success')).catch(() => console.log('this is user audio fail'));
        audioRef.current.addEventListener('ended', () => {
          audioRef.current = null;
        });
      }
    } catch (error) {
      console.log(error)
    }
  };

  function format(value) {
    if (typeof value !== 'string' || value.trim() === '') {
      return 'Unknown';
    }
    const fullName = value.charAt(0).toUpperCase() + value.slice(1);
    return reduceLength(fullName);
  }

  const reduceLength = (value) => {
    if (typeof value !== 'string') {
      return "";
    }
    return value.length > 9 ? value.slice(0, 9) + '...' : value;
  };

  const dialcall = (dial) => {
    let data = {
      number: dial
    }
    window.postMessage({ type: 'Manual', data: data });
  }

  const maskPhoneNumber = (number, visibleDigits = 3) => {
    if (!number) return "";
    const str = String(number);
    if (str.length <= visibleDigits) return str;
    return "X".repeat(str.length - visibleDigits) + str.slice(-visibleDigits);
  };


   const crmviewlead = (leadId) => {
      let view_url;
      const viewlead_payload = {
        customer_id:leadId,
        module: customerinfo.module ,
      };
      dispatch(CrmUrl(viewlead_payload))
        .then((crmurlresponse) => {
          if (crmurlresponse.status == 200) {
            view_url = crmurlresponse.data.url.view_url;
            console.log('view url',view_url);
            window.open(`${view_url}`);
          }
        })
        .catch((err) => {
          return err;
        });
    };
  

  return (
    <div className="App">
      <div className="contact-list">
        <div className="contact-list-title"></div>

        {/* Tab Navigation */}
        <div className="call-log-tabs">
          <button
            className={`tab-button ${activeTab === 'all' ? 'active' : ''}`}
            onClick={() => setActiveTab('all')}
          >
            All Calls
          </button>
          <button
            className={`tab-button ${activeTab === 'missed' ? 'active' : ''}`}
            onClick={() => setActiveTab('missed')}
          >
            Missed Calls
          </button>
        </div>

        <div className="search-container">
          <input
            className="calllogsearch"
            type="text"
            placeholder="Search Number"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {filteredContacts.length === 0 ? (
          <p className="no-data-message">No {activeTab === 'missed' ? 'Missed' : ''} Calls Found</p>
        ) : (
          <ul className="contact-items">
            {filteredContacts.map((contact, index) => {
              const contactElement = (
                <li key={contact.id} className="contact-item">
                  <div className="click-to-call-icon">
                    {userPermission.click_to_call && (
                      <FiPhone
                        style={{ color: "green", cursor: "pointer", fontSize: "20px" }}
                        onClick={() => dialcall(contact.phone_number)}
                        title="Click to call"
                      />
                    )}
                  </div>

                  <div className="contact-details">
                    {contact.status !== "ABANDON" && (
                      <h5>{format(contact.name)}</h5>
                    )}


                    <div className="pnumber">
                      {config.config[0]?.masking ? maskPhoneNumber(contact.phone_number, config.config[0]?.masking_visible_char) : contact.phone_number}
                      {contact.call_type === "INBOUND" ? (
                        <FiPhoneIncoming
                          className="call-direction-icon inbound"
                          title="Inbound Call"
                        />
                      ) : contact.call_type === "MANUAL" ? (
                        <FiPhoneOutgoing
                          className="call-direction-icon outbound"
                          title="Outbound Call"
                        />
                      ) : null}



                      {/* eye */}
                      <FontAwesomeIcon
                        title='View Info'
                        icon={faEye}
                        // onClick={()=>crmviewlead(contact.lead_id)}
                        onClick={() => contact.lead_id && crmviewlead(contact.lead_id)}
                        style={{ color: "#2196F3", 
                        fontSize: "14px", paddingLeft: "3px", paddingBottom: '2px',
                        cursor: contact.lead_id ? "pointer" : "not-allowed",
                        opacity: contact.lead_id ? 1 : 0.5
                        }} />



                    </div>

                    <div className="call-type">{callDates[index]}</div>
                    {contact.status !== "ABANDON" ? (
                      <div className={`call-status-text ${contact.status === 'ABANDON' ? 'missed-call' : ''}`}>
                        {formatStatus(contact.status)}
                      </div>
                    ) : (
                      <div className='missed-call'>

                        {contact.queue}
                      </div>
                    )}



                    {contact.status !== "ABANDON" && (
                      <div className="icons">
                        <FiMic
                          onClick={() => {
                            if (contact.record_location !== "") {
                              fetchCallRecording(contact.record_location);
                            }
                          }}
                          className={
                            contact.record_location === "" ? "icon-disabled" : "rec-icon"
                          }
                          title={
                            contact.record_location === ""
                              ? "No recording available"
                              : "Play recording"
                          }
                          style={{ cursor: contact.record_location === "" ? "default" : "pointer" }}
                        />
                        <span className="call-duration">{contact.formatted_talk_time}</span>
                      </div>
                    )}

                  </div>
                </li>
              );

              if (filteredContacts.length === index + 1) {
                return (
                  <li ref={lastContactCallback} key={contact.id}>
                    {contactElement}
                  </li>
                );
              } else {
                return contactElement;
              }
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

function formatDate(datestring) {
  const date = new Date(datestring);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export default CallLog;